import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TrasladosTable() {
  const [traslados, setTraslados] = useState([]);
  const [filteredTraslados, setFilteredTraslados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTercero, setSelectedTercero] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTraslados();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTraslados();
  }, [searchTerm, searchTercero,startDate,endDate, traslados]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTraslados = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/traslados');
      setTraslados(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los traslados. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTraslados = () => {
    let filtered = traslados.filter(traslado =>
      traslado.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (traslado.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === traslado.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!startDate || new Date(traslado.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(traslado.fecha) <= new Date(endDate))
    );
    setFilteredTraslados(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este traslado?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/traslados/${id}`);
        fetchTraslados();
      } catch (err) {
        setError('Error al eliminar el traslado. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdftrasladoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Traslado_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del traslado.');
    }
  };




  /*
  const handlePrint = async (sepulturaId) => {
    if (!sepulturaId) return;
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/pdftrasladoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Traslado_${sepulturaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del traslado.');
    }
  };
*/

  const totalPages = Math.ceil(filteredTraslados.length / itemsPerPage);
  const currentItems = filteredTraslados.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Traslados</h1>
      <div className="flex justify-between mb-4">

      <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


    {/* anterior    
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
 */}       
        <Link to="/home/traslados/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Traslado
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>


      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Origen ID</th>
              <th className="px-6 py-3">Destino ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((traslado) => (
              <tr key={traslado.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{traslado.id}</td>
                <td className="px-6 py-4">{traslado.fecha}</td>
                <td className="px-6 py-4">{traslado.terceroId}</td>
                <td className="px-6 py-4">{traslado.sepulturaId}</td>
                <td className="px-6 py-4">{traslado.origenId}</td>
                <td className="px-6 py-4">{traslado.destineId}</td>
                <td className="px-6 py-4">{traslado.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/traslados/${traslado.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/traslados/edit/${traslado.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(traslado.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                 <button onClick={() => handlePrint(traslado.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TrasladosTable() {
  const [traslados, setTraslados] = useState([]);
  const [filteredTraslados, setFilteredTraslados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTraslados();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTraslados();
  }, [searchTerm, searchTercero,startDate,endDate, traslados]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTraslados = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/traslados');
      setTraslados(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los traslados. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTraslados = () => {
    let filtered = traslados.filter(traslado =>
      traslado.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (traslado.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === traslado.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!startDate || new Date(traslado.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(traslado.fecha) <= new Date(endDate))
    );
    setFilteredTraslados(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este traslado?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/traslados/${id}`);
        fetchTraslados();
      } catch (err) {
        setError('Error al eliminar el traslado. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (terceroId) => {
    if (!terceroId) return;
    try {
      const response = await axios.get(`/sepulturasc/${terceroId}/pdftrasladoc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Traslado_${terceroId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF del traslado.');
    }
  };


  const totalPages = Math.ceil(filteredTraslados.length / itemsPerPage);
  const currentItems = filteredTraslados.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Traslados</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/traslados/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Traslado
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>


      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Origen ID</th>
              <th className="px-6 py-3">Destino ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((traslado) => (
              <tr key={traslado.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{traslado.id}</td>
                <td className="px-6 py-4">{traslado.fecha}</td>
                <td className="px-6 py-4">{traslado.terceroId}</td>
                <td className="px-6 py-4">{traslado.sepulturaId}</td>
                <td className="px-6 py-4">{traslado.origenId}</td>
                <td className="px-6 py-4">{traslado.destineId}</td>
                <td className="px-6 py-4">{traslado.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/traslados/${traslado.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/traslados/edit/${traslado.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(traslado.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                 <button onClick={() => handlePrint(traslado.terceroId)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/* CORRECTO FILTRO TERCEROS
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TrasladosTable() {
  const [traslados, setTraslados] = useState([]);
  const [filteredTraslados, setFilteredTraslados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTraslados();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTraslados();
  }, [searchTerm, searchTercero, traslados]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTraslados = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/traslados');
      setTraslados(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los traslados. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTraslados = () => {
    let filtered = traslados.filter(traslado =>
      traslado.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (traslado.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === traslado.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      ))
    );
    setFilteredTraslados(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este traslado?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/traslados/${id}`);
        fetchTraslados();
      } catch (err) {
        setError('Error al eliminar el traslado. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredTraslados.length / itemsPerPage);
  const currentItems = filteredTraslados.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Traslados</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/traslados/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Traslado
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Origen ID</th>
              <th className="px-6 py-3">Destino ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((traslado) => (
              <tr key={traslado.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{traslado.id}</td>
                <td className="px-6 py-4">{traslado.fecha}</td>
                <td className="px-6 py-4">{traslado.terceroId}</td>
                <td className="px-6 py-4">{traslado.sepulturaId}</td>
                <td className="px-6 py-4">{traslado.origenId}</td>
                <td className="px-6 py-4">{traslado.destineId}</td>
                <td className="px-6 py-4">{traslado.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/traslados/${traslado.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/traslados/edit/${traslado.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(traslado.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/


/* CORRECTO
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TrasladosTable() {
  const [traslados, setTraslados] = useState([]);
  const [filteredTraslados, setFilteredTraslados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTraslados();
  }, []);

  useEffect(() => {
    filterAndSortTraslados();
  }, [searchTerm, traslados, sortColumn, sortDirection]);

  const fetchTraslados = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/traslados');
      setTraslados(response.data);
      setFilteredTraslados(response.data);
    } catch (err) {
      setError('Error al cargar los traslados. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTraslados = () => {
    let filtered = traslados.filter(traslado =>
      traslado.terceroId.toString().includes(searchTerm)
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTraslados(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTraslado = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este traslado?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/traslados/${id}`);
        fetchTraslados();
      } catch (err) {
        setError('Error al eliminar el traslado. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTraslados.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(filteredTraslados.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Traslados</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Traslados</h2>
          <Link
            to="/home/traslados/add"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
          >
            <FaPlus className="mr-2" /> Añadir Traslado
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Tercero ID"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {[ 'id', 'terceroId', 'fecha', 'observaciones', 'sepulturaId', 'oringenId', 'destineId' ].map((col) => (
                  <th
                    key={col}
                    className="px-6 py-3 cursor-pointer"
                    onClick={() => handleSort(col)}
                  >
                    {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                    {sortColumn === col &&
                      (sortDirection === 'asc' ? (
                        <FaSortAmountUp />
                      ) : (
                        <FaSortAmountDown />
                      ))}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((traslado) => (
                <tr key={traslado.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{traslado.id}</td>
                  <td className="px-6 py-4">{traslado.terceroId}</td>
                  <td className="px-6 py-4">{traslado.fecha}</td>
                  <td className="px-6 py-4">{traslado.observaciones}</td>
                  <td className="px-6 py-4">{traslado.sepulturaId}</td>
                  <td className="px-6 py-4">{traslado.oringenId}</td>
                  <td className="px-6 py-4">{traslado.destineId}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/traslados/${traslado.id}`} className="text-blue-600 hover:text-blue-900">
                      <FaEye />
                    </Link>
                    <Link to={`/home/traslados/edit/${traslado.id}`} className="text-green-600 hover:text-green-900">
                      <FaEdit />
                    </Link>
                    <button onClick={() => handleDeleteTraslado(traslado.id)} className="text-red-600 hover:text-red-900">
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/